module.exports = __webpack_public_path__ + "img/WT-01_1125.cc7d01c3.png";